interface Props {
    children?: any;
    addClasses?: string | null;
}

const Panel: React.FC<Props> = ({ children, addClasses }) => {
    if (!addClasses) {
        addClasses = 'bg-white border-stroke';
    }

    return (
        <div
            className={`rounded-sm border p-[24px] shadow-default ${addClasses}`}
        >
            {children}
        </div>
    );
};

export default Panel;
